module.exports = __webpack_public_path__ + "img/benovelty-open-banking-sdk.a7268f6c.svg";